import React from 'react';
import styled from 'styled-components';
import { expertise } from '@config';
import FeatureIcon from '@components/icons/feature';

const StyledSection = styled.section`
  ${({ theme }) => theme.mixins.section};
  background: var(--paper);
`;

const StyledInner = styled.div`
  ${({ theme }) => theme.mixins.container};
`;

const StyledHead = styled.div`
  max-width: 680px;
  margin-bottom: 52px;

  @media (max-width: 768px) {
    margin-bottom: 36px;
  }
`;

const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 22px;

  @media (max-width: 980px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 620px) {
    grid-template-columns: 1fr;
  }
`;

const StyledCard = styled.div`
  padding: 32px;
  border: 1px solid var(--line);
  border-radius: var(--radius-lg);
  background: var(--paper-soft);
  transition: var(--transition);

  &:hover {
    transform: translateY(-4px);
    border-color: rgba(86, 112, 246, 0.4);
    box-shadow: var(--shadow-soft);
  }

  .icon {
    ${({ theme }) => theme.mixins.flexCenter};
    width: 50px;
    height: 50px;
    margin-bottom: 20px;
    border-radius: 14px;
    color: var(--blue);
    background: rgba(86, 112, 246, 0.12);
  }

  h3 {
    margin: 0 0 10px;
    font-size: var(--fz-xl);
  }

  p {
    margin: 0;
    color: var(--text-soft);
    font-size: var(--fz-sm);
    line-height: 1.65;
  }
`;

const Expertise = () => (
  <StyledSection id="expertise">
    <StyledInner>
      <StyledHead>
        <p className="eyebrow">Экспертиза</p>
        <h2>Почему можно доверять проекту</h2>
        <p style={{ color: 'var(--text-soft)' }}>
          Сочетание академической подготовки, практического опыта и современного технологического
          подхода.
        </p>
      </StyledHead>

      <StyledGrid>
        {expertise.map(item => (
          <StyledCard key={item.title}>
            <span className="icon">
              <FeatureIcon name={item.icon} size={24} />
            </span>
            <h3>{item.title}</h3>
            <p>{item.text}</p>
          </StyledCard>
        ))}
      </StyledGrid>
    </StyledInner>
  </StyledSection>
);

export default Expertise;
